import { MapPin, Calendar } from "lucide-react";

const TAG_COLORS = {
  urgent: "bg-red-100 text-red-700",
  high_risk: "bg-amber-100 text-amber-700",
  VIP: "bg-purple-100 text-purple-700",
  follow_up: "bg-blue-100 text-blue-700",
};

export const PipelineView = ({ stages, data, getStatusColor, onView, onEdit, onToggleTag }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-7 gap-3" data-testid="pipeline-view">
    {stages.map((stage) => (
      <div key={stage.key} className={`border-t-4 ${stage.color} bg-white border border-slate-200 min-h-[200px]`}>
        <div className="p-3 border-b border-slate-100 flex items-center justify-between">
          <span className="text-xs font-bold text-slate-600 uppercase tracking-wide">{stage.label}</span>
          <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full font-bold">
            {data[stage.key]?.length || 0}
          </span>
        </div>
        <div className="p-2 space-y-2 max-h-[500px] overflow-y-auto">
          {(data[stage.key] || []).map((q) => (
            <div
              key={q.quote_id}
              className="bg-white border border-slate-200 p-3 hover:shadow-sm cursor-pointer transition-shadow"
              onClick={() => onView(q)}
              data-testid={`pipeline-card-${q.quote_id}`}
            >
              <div className="text-sm font-medium text-[#0F172A] truncate">{q.customer?.name || "N/A"}</div>
              <div className="text-xs text-slate-500 mt-1 flex items-center gap-1">
                <MapPin className="w-3 h-3" />
                {q.from_postcode} → {q.to_postcode}
              </div>
              <div className="text-xs text-slate-400 mt-1 flex items-center gap-1">
                <Calendar className="w-3 h-3" />
                {q.move_date}
              </div>
              {(q.customer_price || q.estimated_price) && (
                <div className="text-sm font-bold text-[#FF5A1F] mt-2">
                  £{(q.final_price || q.customer_price || q.estimated_price || 0).toFixed(2)}
                </div>
              )}
              {q.tags?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {q.tags.map((t) => (
                    <span key={t} className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${TAG_COLORS[t] || "bg-slate-100 text-slate-600"}`}>
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
